/*! react-toggle-switch v0.5.4 | (c) 2017 Trend Micro Inc. | MIT | https://github.com/trendmicro-frontend/react-toggle-switch */
module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _reactAnchor = __webpack_require__(3);

var _reactAnchor2 = _interopRequireDefault(_reactAnchor);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToggleSwitch = (_temp2 = _class = function (_PureComponent) {
    _inherits(ToggleSwitch, _PureComponent);

    function ToggleSwitch() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ToggleSwitch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToggleSwitch.__proto__ || Object.getPrototypeOf(ToggleSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            checked: _this.props.checked
        }, _this.actions = {
            handleChange: function handleChange(event) {
                event.preventDefault();

                if (_this.props.disabled) {
                    return;
                }

                if (typeof _this.props.onChange === 'function') {
                    _this.props.onChange(event);
                    return;
                }

                _this.setState({ checked: !_this.state.checked });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ToggleSwitch, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ checked: nextProps.checked });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                disabled = _props.disabled,
                size = _props.size,
                props = _objectWithoutProperties(_props, ['className', 'disabled', 'size']);

            delete props.checked;
            delete props.onChange;

            return _react2.default.createElement(
                _reactAnchor2.default,
                _extends({}, props, {
                    className: (0, _classnames2.default)(className, _index2.default.switch, _defineProperty({}, _index2.default.switchSm, size === 'sm' || size === 'small'), _defineProperty({}, _index2.default.checked, this.state.checked)),
                    onClick: this.actions.handleChange
                }),
                _react2.default.createElement('div', {
                    className: (0, _classnames2.default)(_index2.default.toggle, _defineProperty({}, _index2.default.toggleSm, size === 'sm' || size === 'small'), _index2.default.round, _defineProperty({}, _index2.default.disabled, disabled))
                })
            );
        }
    }, {
        key: 'checked',
        get: function get() {
            return this.state.checked;
        }
    }]);

    return ToggleSwitch;
}(_react.PureComponent), _class.propTypes = {
    checked: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    size: _propTypes2.default.oneOf(['lg', 'large', 'sm', 'small'])
}, _class.defaultProps = {
    checked: false,
    disabled: false,
    size: 'lg'
}, _temp2);
exports.default = ToggleSwitch;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ToggleSwitch = __webpack_require__(0);

var _ToggleSwitch2 = _interopRequireDefault(_ToggleSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _ToggleSwitch2.default;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"switch":"toggle-switch---switch---3EchW","switch-sm":"toggle-switch---switch-sm---31JjY","switchSm":"toggle-switch---switch-sm---31JjY","toggle":"toggle-switch---toggle---mncCu","disabled":"toggle-switch---disabled---eCY9b","checked":"toggle-switch---checked---3aC9B","toggle-sm":"toggle-switch---toggle-sm---20q-N","toggleSm":"toggle-switch---toggle-sm---20q-N","round":"toggle-switch---round---1fvZN"};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@trendmicro/react-anchor");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ })
/******/ ]);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@trendmicro/react-toggle-switch/lib/index.js
// module id = 114
// module chunks = 0